import type {
  ListUsersParams,
  UserRepository,
} from '@/domain/users/repositories/user_repository'
import type { UpdateUserPayload, UserDetail, UserListItem } from '@/domain/users/entities/user.entity'
import {
  extractUserList,
  mapUserDetailResponse,
} from '@/data/users/mappers/user.mapper'
import { UsersRemoteDatasource } from '../datasources/users_remote_datasource'

export class UserRepositoryImpl implements UserRepository {
  constructor(private readonly remote: UsersRemoteDatasource = new UsersRemoteDatasource()) {}

  async list(params: ListUsersParams): Promise<UserListItem[]> {
    const raw = await this.remote.list(params.page, params.limit)
    return extractUserList(raw)
  }

  async getById(id: string): Promise<UserDetail> {
    const raw = await this.remote.getById(id)
    return mapUserDetailResponse(raw)
  }

  async update(id: string, payload: UpdateUserPayload): Promise<UserDetail> {
    const raw = await this.remote.update(id, payload)
    return mapUserDetailResponse(raw)
  }

  async delete(id: string): Promise<void> {
    await this.remote.delete(id)
  }
}

export const userRepository = new UserRepositoryImpl()
